import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import { getBalance } from "../../utils/contractHelpers";
import { USDT_CONTRACT_ADDRESS } from "../../utils/Enviroment";
import { useWeb3React } from "@web3-react/core";
import { useRecoilValue } from "recoil";
import { userSmartAccount } from "../../components/recoilAtom";
import Web3 from "web3";

const Balance = () => {
  const { account } = useWeb3React();
  const web3 = useWeb3();
  const tokenAddress = USDT_CONTRACT_ADDRESS;
  const smartAccount = useRecoilValue(userSmartAccount);
  const web4 = new Web3(
    "https://dimensional-serene-wish.base-mainnet.quiknode.pro/384f047fe7195b52a94e84a42dbc1cc3541a48e5/"
  );

  const BalanceHook = useCallback(
    async (internal) => {
      const contract = getBalance(tokenAddress, web4);
      if (!contract) {
        console.error("Contract not initialized properly.");
        return "0";
      }

      try {
        const balance = await contract?.methods?.balanceOf(internal).call();
        const formattedBalance = web3.utils.fromWei(String(balance), "mwei");
        return formattedBalance;
      } catch (error) {
        console.error("Error fetching balance:", error.message || error);
        return "0";
      }
    },
    [account, web3, smartAccount]
  );

  return { BalanceHook };
};

export default Balance;
